import { Config } from './dreadcabinet';
import { DEFAULT_CONCURRENCY, DEFAULT_EXTENSIONS, DEFAULT_INPUT_DIRECTORY, DEFAULT_INPUT_FILENAME_OPTIONS, DEFAULT_INPUT_STRUCTURE, DEFAULT_OUTPUT_DIRECTORY, DEFAULT_OUTPUT_FILENAME_OPTIONS, DEFAULT_OUTPUT_STRUCTURE, DEFAULT_RECURSIVE, DEFAULT_TIMEZONE } from './constants';
import { DefaultOptions, Feature } from './dreadcabinet';

export const applyDefaults = (config: Partial<Config>, features: Feature[], defaults: DefaultOptions): Config => {
    const configWithDefaults = {
        ...config,
    }

    configWithDefaults.timezone = config.timezone || (defaults?.timezone || DEFAULT_TIMEZONE);
    if (features.includes('input')) {
        configWithDefaults.recursive = config.recursive === undefined ? (defaults?.recursive ?? DEFAULT_RECURSIVE) : config.recursive;
        configWithDefaults.inputDirectory = config.inputDirectory || (defaults?.inputDirectory || DEFAULT_INPUT_DIRECTORY);
        // Ensure concurrency is a valid positive integer, otherwise use default
        if (config.concurrency === undefined || !Number.isInteger(config.concurrency) || config.concurrency < 1) {
            configWithDefaults.concurrency = defaults?.concurrency || DEFAULT_CONCURRENCY;
        } else {
            configWithDefaults.concurrency = config.concurrency;
        }
    }
    if (features.includes('output')) {
        configWithDefaults.outputDirectory = config.outputDirectory || (defaults?.outputDirectory || DEFAULT_OUTPUT_DIRECTORY);
    }
    if (features.includes('structured-output')) {
        configWithDefaults.outputStructure = config.outputStructure || (defaults?.outputStructure || DEFAULT_OUTPUT_STRUCTURE);
        configWithDefaults.outputFilenameOptions = config.outputFilenameOptions || (defaults?.outputFilenameOptions || DEFAULT_OUTPUT_FILENAME_OPTIONS);
    }
    if (features.includes('extensions')) {
        configWithDefaults.extensions = config.extensions || (defaults?.extensions || DEFAULT_EXTENSIONS);
    }

    if (features.includes('structured-input')) {
        configWithDefaults.inputStructure = config.inputStructure || (defaults?.inputStructure || DEFAULT_INPUT_STRUCTURE);
        configWithDefaults.inputFilenameOptions = config.inputFilenameOptions || (defaults?.inputFilenameOptions || DEFAULT_INPUT_FILENAME_OPTIONS);
    }

    return configWithDefaults as Config;
}

